module.exports = __webpack_public_path__ + "img/old2.41fb35f9.jpg";